import Vue from "vue";
import VueRouter from "vue-router";
import VueMq from "vue-mq";
import App from "./App.vue";

Vue.use(VueRouter);

Vue.use(VueMq, {
  breakpoints: {
    sm: 600,
    md: 1024,
    lg: Infinity
  },
  defaultBreakpoint: "lg"
});

const router = new VueRouter({
  mode: "history",
  routes: [{ path: "/" }],
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App)
}).$mount("#app");
